import { BookingFieldApi } from './BookingConfig/fieldsBookingConf';

export enum BookingConfigEnum {
  Brand = 'brand',
  BrandCode = 'brandCode',
  VisualVariant = 'visualVariant',
  Locale = 'locale',
  DateFormat = 'dateFormat',
  DateTimeFormat = 'dateTimeFormat',
  BirthdayFormat = 'birthdayFormat',
  B2cUrl = 'b2cUrl',
  PdsUrl = 'pdsUrl',
  DrupalUrl = 'drupalUrl',
  Country = 'country',
  Currency = 'currency',
  DataCenter = 'dataCenter',
  PaymentProvider = 'paymentProvider',
  ClientId = 'client_id',
  ClientSecret = 'client_secret',
  Catalogs = 'catalogs',
  Channel = 'channel',
  Type = 'type',
  BookingSteps = 'bookingSteps',
  BookingFieldsApi = 'bookingFieldsApi',
  Validation = 'validation',
  AgentScripts = 'agentScripts',
  Consents = 'consents',
  AbandonReasons = 'abandonReasons',
  PromotionCodes = 'promotionCodes',
  DiscountReasons = 'discountReasons',
  BrandProductReview = 'brandProductReview',
  Layout = 'layout',
  PaymentConfig = 'paymentConfig',
  CreditPaymentEnabled = 'creditPaymentEnabled',
  TripCostVisible = 'tripCostVisible',
}

export enum BookingStepIndex {
  QuotationFrom = 1,
  QuotationProposals = 2,
  QuotationInformationForm = 3,
  QuotationRecapDeclarations = 4,
  QuotationConfirmation = 5,
}

export interface BookingConfig {
  [BookingConfigEnum.Brand]: string;
  [BookingConfigEnum.BrandCode]: string;
  [BookingConfigEnum.VisualVariant]?: VisualVariant;
  [BookingConfigEnum.Locale]: string;
  [BookingConfigEnum.DateFormat]: string;
  [BookingConfigEnum.DateTimeFormat]: string;
  [BookingConfigEnum.BirthdayFormat]: string;
  [BookingConfigEnum.B2cUrl]: string;
  [BookingConfigEnum.PdsUrl]: string;
  [BookingConfigEnum.DrupalUrl]: string;
  [BookingConfigEnum.Country]: Country;
  [BookingConfigEnum.Currency]: Currency;
  [BookingConfigEnum.DataCenter]: DataCenter;
  [BookingConfigEnum.PaymentProvider]: string;
  [BookingConfigEnum.ClientId]: string;
  [BookingConfigEnum.ClientSecret]: string;
  [BookingConfigEnum.Catalogs]: BookingCatalog[];
  [BookingConfigEnum.Channel]: BookingChannel;
  [BookingConfigEnum.Type]: ConfigTypeEnum;
  [BookingConfigEnum.BookingSteps]: BookingStep[];
  [BookingConfigEnum.BookingFieldsApi]: BookingFieldApi[];
  [BookingConfigEnum.Validation]: BookingValidation;
  [BookingConfigEnum.AbandonReasons]: AbandonReason[];
  [BookingConfigEnum.PromotionCodes]: PromotionCode[];
  [BookingConfigEnum.DiscountReasons]: DiscountReason[];
  [BookingConfigEnum.Layout]: string;
  [BookingConfigEnum.PaymentConfig]: PaymentConfig;
  [BookingConfigEnum.BrandProductReview]?: string;
  [BookingConfigEnum.CreditPaymentEnabled]?: boolean;
  [BookingConfigEnum.TripCostVisible]?: boolean;
}

export enum BannerEnum {
  Id = 'id',
  Content = 'content',
}
export enum ConfigTypeEnum {
  WHITE_LABEL = 'WHITELABEL',
  RETAIL = 'RETAIL',
  INPATH = 'INPATH',
}

export enum BrandShortcuts {
  FCB = 'FCB',
  CAB = 'CAB',
  TAB = 'TAB',
}

export type VisualVariant = 'legacy' | 'refresh';

export interface Banner {
  [BannerEnum.Id]: string;
  [BannerEnum.Content]: string;
}

export enum AgentScriptsEnum {
  Text = 'text',
  Texts = 'texts',
}

export interface AgentScripts {
  [AgentScriptsEnum.Text]?: string;
  [AgentScriptsEnum.Texts]?: { [key: string]: string };
}

export enum BookingStepEnum {
  Id = 'id',
  Label = 'label',
  Locale = 'locale',
  KeyName = 'keyName',
  StepNameApi = 'stepNameApi',
  Component = 'component',
  SendQuoteEmailEnabled = 'sendQuoteEmailEnabled',
  HeaderText = 'headerText',
  SendQuoteOnEnterStep = 'sendQuoteOnEnterStep',
  FooterText = 'footerText',
  Cards = 'cards',
  Widgets = 'widgets',
  Banner = 'banner',
  AdditionalData = 'additionalData',
  AgentScripts = 'agentScripts',
}

export interface BookingStep {
  [BookingStepEnum.Id]: number;
  [BookingStepEnum.Label]: string;
  [BookingStepEnum.Locale]: string;
  [BookingStepEnum.KeyName]: string;
  [BookingStepEnum.StepNameApi]: string;
  [BookingStepEnum.Component]: string;
  [BookingStepEnum.SendQuoteEmailEnabled]: boolean;
  [BookingStepEnum.SendQuoteOnEnterStep]: boolean;
  [BookingStepEnum.HeaderText]: string;
  [BookingStepEnum.FooterText]: string;
  [BookingStepEnum.Cards]: BookingSubStep[];
  [BookingStepEnum.Widgets]: BookingStepWidget;
  [BookingStepEnum.Banner]?: Banner;
  [BookingStepEnum.AdditionalData]?: GenericObject;
  [BookingStepEnum.AgentScripts]?: AgentScripts;
}

export enum BookingStepWidgetEnum {
  ProductReview = 'productReview',
  CanstarComparison = 'canstarComparison',
  UsefulLinks = 'usefulLinks',
}

export interface BookingStepWidget {
  [BookingStepWidgetEnum.ProductReview]?: ProductReview;
  [BookingStepWidgetEnum.CanstarComparison]?: CanstarComparison;
  [BookingStepWidgetEnum.UsefulLinks]?: UsefulLink[];
}

export enum ProductReviewEnum {
  Brand = 'brand',
  Url = 'url',
  Title = 'title',
}

export interface ProductReview {
  [ProductReviewEnum.Brand]: string;
  [ProductReviewEnum.Url]: string;
  [ProductReviewEnum.Title]: string;
}

export type CanstarComparison = string[];

export enum UsefulLinkEnum {
  Title = 'title',
  Link = 'link',
}

export interface UsefulLink {
  [UsefulLinkEnum.Title]: string;
  [UsefulLinkEnum.Link]: string;
}

export enum UsefulLinksEnum {
  Title = 'title',
  Links = 'links',
}

export interface UsefulLinks {
  [UsefulLinksEnum.Title]: string;
  [UsefulLinksEnum.Links]: UsefulLink[];
}

export enum BookingSubStepEnum {
  Id = 'id',
  Label = 'label',
  KeyName = 'keyName',
  Component = 'component',
  Description = 'description',
  Locale = 'locale',
  Options = 'options',
  AgentScripts = 'agentScripts',
  Sublabel = 'sublabel',
}

export enum ProductTypeEnum {
  AMT = 'amt',
  ONE_TRIP = 'oneTrip',
}

export interface BookingSubStep {
  [BookingSubStepEnum.Id]?: number;
  [BookingSubStepEnum.KeyName]: BookingSubStepValueEnum;
  [BookingSubStepEnum.Label]: string;
  [BookingSubStepEnum.Component]: string;
  [BookingSubStepEnum.Description]?: string;
  [BookingSubStepEnum.Locale]?: string;
  [BookingSubStepEnum.Options]: BookingSubStepOption[] | Declaration[];
  [BookingSubStepEnum.AgentScripts]?: AgentScripts;
  [BookingSubStepEnum.Sublabel]?: string;
}

export enum BookingSubStepOptionEnum {
  Label = 'label',
  Description = 'description',
  Value = 'value',
  Image = 'image',
  Icon = 'icon',
  Locale = 'locale',
  Version = 'version',
  isDefault = 'isDefault',
  isRestricted = 'isRestricted',
  AgentExlusive = 'agentExlusive',
  MappingValue = 'mappingValue',
  MappingValueWithCruise = 'mappingValueWithCruise',
  CatalogSpecific = 'catalogSpecific',
  Group = 'group',
}

export interface BookingCatalog {
  code: string;
  isAnnual: boolean;
  id?: number;
}

export interface BookingChannel {
  businessUnits: BusinessUnit[];
  catalogGroup: string;
  id: number;
  name: string;
  platform: string;
  portalApi: string;
  psClient: string;
  psPartnerEndpoint: string;
  psPlatform: string;
  slug: string;
  subType: string;
}

export interface BusinessUnit {
  code: string;
  shopId: string;
  shopName: string;
  id: number;
  divisionName: string;
  divisionCode: string;
  static: boolean;
}

export interface PricingData {
  priceNet: number;
  grossPremium: number;
  currency: string;
}

export interface BookingSubStepOption {
  [BookingSubStepOptionEnum.Label]: string;
  [BookingSubStepOptionEnum.Description]?: string;
  [BookingSubStepOptionEnum.Value]: string;
  [BookingSubStepOptionEnum.Image]?: string;
  [BookingSubStepOptionEnum.Icon]?: string;
  [BookingSubStepOptionEnum.Version]?: number;
  [BookingSubStepOptionEnum.Locale]?: string;
  [BookingSubStepOptionEnum.isDefault]?: string;
  [BookingSubStepOptionEnum.isRestricted]?: boolean;
  [BookingSubStepOptionEnum.AgentExlusive]?: boolean;
  [BookingSubStepOptionEnum.MappingValue]?: string;
  [BookingSubStepOptionEnum.MappingValueWithCruise]?: string;
  [BookingSubStepOptionEnum.CatalogSpecific]?: CatalogSpecific[];
  [BookingSubStepOptionEnum.Group]?: boolean;
}

export enum BookingStepValueEnum {
  CurrentStep = 'currentStep',
  Partner = 'partner',
  AggregatorId = 'aggregatorId',
  AffiliateId = 'affiliateId',
  QuotationForm = 'quotationForm',
  QuotationProposals = 'quotationProposals',
  QuotationInformation = 'quotationInformationForm',
  QuotationRecapDeclaration = 'quotationRecapDeclarations',
  QuotationPreliminaryDeclarations = 'quotationPreliminaryDeclarations',
  QuotationConfirmation = 'quotationConfirmation',
  ExtraFields = 'extraFields',
}

export enum BookingSubStepValueEnum {
  TripDetails = 'tripDetails',
  GeographicalZone = 'geographicalZone',
  DepartureDate = 'departureDate',
  ReturnDate = 'returnDate',
  TravellersAge = 'travellersAge',
  PromoCode = 'promoCode',
  TotalPrice = 'totalPrice',
  TripCost = 'tripCost',
  Currency = 'currency',
  Proposal = 'proposal',
  Tables = 'tables',
  Addons = 'addons',
  Excess = 'excess',
  CancellationLimit = 'cancellationLimit',
  ProductType = 'productType',
  InformationData = 'informationData',
  InformationPersonal = 'informationPersonal',
  InformationTravellers = 'informationTravellers',
  InformationMedical = 'informationMedical',
  MedicalDisclaimerConsent = 'medicalDisclaimerConsent',
  MedicalScreening = 'medicalScreening',
  PreflightConsents = 'preflightConsents',
  PreflightChecks = 'preflightChecks',
  Consents = 'consents',
  MaxTripDuration = 'maxTripDuration',
  CreditAmount = 'creditAmount',
  MedicalPriceBreakdown = 'medicalPriceBreakdown',
  IsPolicyHolderTravelling = 'isPolicyHolderTravelling',
  AgentsDiscount = 'agentsDiscount',
  PromoRate = 'promoRate',
  FamCoupleRate = 'famCoupleRate',
  ActiveSubStep = 'activeSubStep',
  InitialQuoteId = 'initialQuoteId',
}

export interface BookingValidation {
  age: AgeValidation[];
  discount: DiscountValidation[];
  ageOfMajorityValidation: AgeOfMajorityValidation[];
  tripDurationValidation: TripDurationValidation[];
  startDateValidation: StartDateValidation[];
  numberOfTravellersValidation: NumberOfTravellersValidation[];
  phoneValidation: PhoneValidation[];
  postalCodeValidation: PostalCodeValidation[];
  medicalScoreValidation: MedicalScoreValidation[];
}

export interface AgeValidation {
  catalog: string;
  firstTravellersAgeValidation: { min: string; max: string };
  otherTravellersAgeValidation: { min: string; max: string };
}

export interface AgeOfMajorityValidation {
  catalog: string;
  age: string;
}

export interface TripDurationDestinationLimit {
  appliedFromAge?: string;
  daysLimit: string;
  destination: string;
}

export interface TripDurationValidation {
  catalog: string;
  min: string;
  ageLimit: string;
  maxIfYoungerThanAgeLimit: string;
  maxIfOlderThanAgeLimit: string;
  destinationLimits: TripDurationDestinationLimit[];
}

export interface StartDateValidation {
  catalog: string;
  ageLimit: string;
  maxIfYoungerThanAgeLimit: string;
  maxIfOlderThanAgeLimit: string;
  maxDaysFromToday: string;
  minDaysFromToday?: string;
}

export interface NumberOfTravellersValidation {
  catalog: string;
  max: string;
}

export interface DiscountValidation {
  catalog: string;
  max: string;
}

export interface PhoneValidation {
  catalog: string;
  length: string;
}

export interface PostalCodeValidation {
  catalog: string;
  length: string;
}

export interface MedicalScoreValidation {
  catalog: string;
  max: string;
}

export interface AgentConfig {
  scripts: AgentConfigScript[];
}

export interface AgentConfigScript {
  step: string;
  substep?: string;
  text?: string;
  texts?: { [key: string]: string };
}

export interface Country {
  country: string;
  locale?: string;
  id?: number;
}

export enum CurrencyEnum {
  Id = 'id',
  Currency = 'currency',
  Locale = 'locale',
  FormatOptions = 'formatOptions',
}

export enum ProgressSteps {
  QuotationForm = 'quotationForm',
  QuotationProposals = 'quotationProposals',
  quotationInformationForm = 'quotationInformationForm',
  QuotationRecapDeclaration = 'quotationRecapDeclarations',
  QuotationConfirmation = 'quotationConfirmation',
}

export interface Currency {
  [CurrencyEnum.Id]?: number;
  [CurrencyEnum.Currency]: string;
  [CurrencyEnum.Locale]: string;
  [CurrencyEnum.FormatOptions]: Intl.NumberFormatOptions;
}

export interface DataCenter {
  code: string;
  cm360Endpoint: string;
  psPartnerEndpoint: string;
  portalUrl: string;
  psPlatform: string;
  cm360Key: string;
  eshopApiEndpoint: string;
  psClient: string;
  widgetUrl: string;
  travelConnectUrl: string;
  catalogGroup: string;
  id?: number;
}

export interface StatesConfig {
  isEnabled: boolean;
  states: GeoState[];
}

export interface GeoState {
  code: string;
  label: string;
}

export interface Declaration {
  id?: number;
  usageType: string;
  description: string;
  agentExlusive: boolean;
  version: number;
  channel: string;
  group: boolean;
  isOptional: boolean;
  label?: string;
  isDefault?: boolean;
  catalogSpecific?: CatalogSpecific[];
}

export interface AbandonReason {
  abandonReasonId: string;
  label: string;
}

export interface PromotionCode {
  name: string;
  value: string;
  discount: number;
  id?: number;
}

export interface DiscountReason {
  label: string;
  value: string;
  isActive: boolean;
}

export enum PaymentConfigEnum {
  PCIPAL = 'PCIPAL',
}

export enum PaymentConfigPCIPALEnum {
  Region = 'region',
  TenantId = 'tenantId',
  Environment = 'environment',
}

export interface PaymentConfigPCIPAL {
  [PaymentConfigPCIPALEnum.Region]: string;
  [PaymentConfigPCIPALEnum.TenantId]: string;
  [PaymentConfigPCIPALEnum.Environment]: string;
}

export interface PaymentConfig {
  [PaymentConfigEnum.PCIPAL]: PaymentConfigPCIPAL;
}

type GenericObject<T = any> = {
  [key: string]: T;
};

export enum AdditionalDataEnum {
  StatesConfig = 'statesConfig',
  Text = 'text',
  PolicyWordingDocs = 'policyWordingDocs',
  PolicyHolderIsTraveller = 'policyHolderIsTraveller',
  TravelerAgeType = 'travelerAgeType',
}

export interface CatalogSpecific {
  code: string;
  isAnnual: boolean;
  id: number;
}

export interface AddonConfig {
  value: string;
  label: string;
  description: string;
}
